var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPointsEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.012 12.592C7.412 12.592 6.884 12.476 6.428 12.244C5.972 12.004 5.62 11.672 5.372 11.248C5.124 10.824 5 10.332 5 9.772V6.808C5 6.248 5.124 5.756 5.372 5.332C5.62 4.908 5.972 4.58 6.428 4.348C6.884 4.116 7.412 4 8.012 4C8.604 4 9.128 4.112 9.584 4.336C10.04 4.56 10.392 4.876 10.64 5.284C10.888 5.692 11.012 6.164 11.012 6.7C11.012 6.74 10.996 6.776 10.964 6.808C10.94 6.832 10.908 6.844 10.868 6.844L9.764 6.904C9.668 6.904 9.62 6.86 9.62 6.772C9.62 6.3 9.472 5.92 9.176 5.632C8.888 5.344 8.5 5.2 8.012 5.2C7.524 5.2 7.132 5.344 6.836 5.632C6.54 5.92 6.392 6.3 6.392 6.772V9.832C6.392 10.296 6.54 10.672 6.836 10.96C7.132 11.248 7.524 11.392 8.012 11.392C8.5 11.392 8.888 11.252 9.176 10.972C9.472 10.684 9.62 10.304 9.62 9.832C9.62 9.744 9.668 9.7 9.764 9.7L10.868 9.748C10.908 9.748 10.94 9.76 10.964 9.784C10.996 9.808 11.012 9.836 11.012 9.868C11.012 10.412 10.888 10.892 10.64 11.308C10.392 11.716 10.04 12.032 9.584 12.256C9.128 12.48 8.604 12.592 8.012 12.592Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPointsEnabled);
export default __webpack_public_path__ + "static/media/icon_points_enabled.043f96e5b9dd709cc193e2e2f69f8aa0.svg";
export { ForwardRef as ReactComponent };